var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.736328H5C2.23858 0.736328 0 2.97491 0 5.73633V13.7363C0 16.4977 2.23858 18.7363 5 18.7363H13C15.7614 18.7363 18 16.4977 18 13.7363V5.73633C18 2.97491 15.7614 0.736328 13 0.736328ZM16.25 13.7363C16.2445 15.5289 14.7926 16.9808 13 16.9863H5C3.20735 16.9808 1.75549 15.5289 1.75 13.7363V5.73633C1.75549 3.94368 3.20735 2.49182 5 2.48633H13C14.7926 2.49182 16.2445 3.94368 16.25 5.73633V13.7363ZM13.75 5.98633C14.3023 5.98633 14.75 5.53861 14.75 4.98633C14.75 4.43405 14.3023 3.98633 13.75 3.98633C13.1977 3.98633 12.75 4.43405 12.75 4.98633C12.75 5.53861 13.1977 5.98633 13.75 5.98633ZM9 5.23633C6.51472 5.23633 4.5 7.25105 4.5 9.73633C4.5 12.2216 6.51472 14.2363 9 14.2363C11.4853 14.2363 13.5 12.2216 13.5 9.73633C13.5027 8.54203 13.0294 7.3959 12.1849 6.55141C11.3404 5.70692 10.1943 5.23367 9 5.23633ZM6.25 9.73633C6.25 11.2551 7.4812 12.4863 9 12.4863C10.5188 12.4863 11.75 11.2551 11.75 9.73633C11.75 8.21753 10.5188 6.98633 9 6.98633C7.4812 6.98633 6.25 8.21753 6.25 9.73633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.08e2ced2c039aa19b110aae7aeaa9e7b.svg";
export { ForwardRef as ReactComponent };